module.exports = __webpack_public_path__ + "static/media/dist-edu.d5395d3f.svg";